import roleService from '@/store/services/roleService'

const state = {

  metaRole: null,
  field: {
    keyword: null,
    paginate: 10,
  },
  keyword_field: null,
  paginate_field: null,
}

const getters = {
  roles: state => (state.metaRole ? state.metaRole.data : []),
  current_page: state => (state.metaRole ? state.metaRole.current_page : 0),
  last_page: state => (state.metaRole ? state.metaRole.last_page : 0),
  per_page: state => (state.metaRole ? state.metaRole.per_page : 0),
}

const actions = {

  // eslint-disable-next-line no-shadow
  getRoles({ commit, state }, { page, field }) {
    if (state.metaRole && state.metaRole.current_page === page
      && state.paginate_field === field.paginate
      && state.keyword_field === field.keyword) return state.metaRole

    return roleService.getRolesList(page, field).then(({ data }) => {
      commit('SET_META_ROLE', data.result)
      commit('SET_KEYWORD_FIELD', field.keyword)
      commit('SET_PAGINATE_FIELD', field.paginate)
      commit('SET_FIELD', field)

      return data
    })
  },

}

const mutations = {

  // eslint-disable-next-line no-shadow
  SET_FIELD(state, objet) {
    state.field = objet
  },
  // eslint-disable-next-line no-shadow
  SET_KEYWORD_FIELD(state, objet) {
    state.keyword_field = objet
  },
  // eslint-disable-next-line no-shadow
  SET_PAGINATE_FIELD(state, objet) {
    state.paginate_field = objet
  },
  // eslint-disable-next-line no-shadow
  SET_META_ROLE(state, objet) {
    state.metaRole = objet
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
